import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9b6b77c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "SubdirPlaceholder" }, "Направление", -1))
const _hoisted_4 = { class: "grid grid-cols-2 gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Создание внутреннего направления",
    overflow: false,
    loading: _ctx.loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(" Выберите направление из списка для закрепления его за родителем "),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.parent), 1),
        _createTextVNode(". ")
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_new_select, {
            placeholder: "Откуда",
            value: _ctx.payload.fromCityId,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload.fromCityId) = $event)),
            disabled: _ctx.loading,
            options: _ctx.data_state.cities.list,
            loading: _ctx.data_state.cities.is_loading,
            failed: _ctx.data_state.cities.is_failed,
            "error-text": "При получении списка произошла ошибка",
            "is-invalid": _ctx.validation$.fromCityId.$error,
            "validation-errors": _ctx.validation$.fromCityId.$errors,
            "can-deselect": "",
            onRefresh: _ctx.loadCities,
            searchable: "",
            onSearch: _ctx.searchCity,
            onOptionBySearch: _ctx.unshiftFindedCity
          }, null, 8, ["value", "disabled", "options", "loading", "failed", "is-invalid", "validation-errors", "onRefresh", "onSearch", "onOptionBySearch"]),
          _createVNode(_component_new_select, {
            placeholder: "Куда",
            value: _ctx.payload.toCityId,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payload.toCityId) = $event)),
            disabled: _ctx.loading,
            options: _ctx.data_state.cities.list,
            loading: _ctx.data_state.cities.is_loading,
            failed: _ctx.data_state.cities.is_failed,
            "error-text": "При получении списка произошла ошибка",
            "is-invalid": _ctx.validation$.toCityId.$error,
            "validation-errors": _ctx.validation$.toCityId.$errors,
            "can-deselect": "",
            onRefresh: _ctx.loadCities,
            searchable: "",
            onSearch: _ctx.searchCity,
            onOptionBySearch: _ctx.unshiftFindedCity
          }, null, 8, ["value", "disabled", "options", "loading", "failed", "is-invalid", "validation-errors", "onRefresh", "onSearch", "onOptionBySearch"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading", "onSubmit", "onCancel"]))
}